// Abstract type intended to be used as a base type for generic types, e.g. `fn<Cfg extends NavigationComponentsConfig>(cfg: Cfg)`

// Abstract type intended to be used as a base type for generic types, e.g. `fn<Cfg extends AppliedComponentsConfig>(cfg: Cfg)`

export const createConfig = config => {
  const applyConfigFn = params => Object.entries(config).reduce((applied, [componentName, definitionGetter]) => {
    applied[componentName] = definitionGetter(params);
    return applied;
  }, {});
  applyConfigFn.spec = config;
  return applyConfigFn;
};